import axios from 'axios';
import { Module } from 'vuex';
import { AuthState, RootState } from '../types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { getSessionId } from '@/utils/session';

const namespaced: boolean = true;

export const state: AuthState = {
	tenantId: null,
	axiosInst: axios.create({
		headers: {
			'X-RESTAURANT-ID': '',
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${null}`,
			'X-SESSION-ID': getSessionId()
		}
	}),
	restaurant: {} as Restaurant,
	restaurants: null,
	switchingLocation: false,
	authGroups: null,
	role: null,
	authenticated: false,
	accessToken: null,
	lastLogin: null,
	idToken: null,
	expiresAt: null,
	posIntegrated: false,
	staffEmail: null,
	employeeId: null,
	employeeName: null,
	createdBy: null,
	pinRole: null
};

export const Auth: Module<AuthState, RootState> = {
	namespaced,
	state,
	mutations,
	getters,
	actions
};

export default Auth;
